import * as React from 'react';
import Menu from '@mui/material/Menu';
import Tooltip from '@mui/material/Tooltip';
import styled from '@emotion/styled';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import moment from 'moment'
import { TextField, Stack, Select, MenuItem, InputLabel, Avatar } from '@mui/material';
import { getProviders } from '../../Controllers/Payments';
import { useEffect } from 'react';
const APP_URL = process.env.REACT_APP_SERVER_URL
let isChanged = false
export default function Filter({ filterState, setFilterState, callFunction }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [provider, setProvider] = React.useState({ list: [] })

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusChange = (event) => {
        setFilterState({ ...filterState, fStatus: event.target.value });
        isChanged = true
    };

    const handleApply = () => {
        if (isChanged) {
            setFilterState({ ...filterState, isApplied: true })
            callFunction(1);
            setAnchorEl(null);
        } else {
                alert("Please select filter")
        }
    }

    const handleClear = () => {
        setFilterState({})
        callFunction(1, true);
        setAnchorEl(null);
        isChanged = false
    }

    useEffect(() => {
        getProviderListing(filterState.provider)
        isChanged = false
    }, [filterState.provider])

    const getProviderListing = async (role) => {
        const res = await getProviders(role)
        if (res.data.status === 200) {
            setProvider({ ...provider, list: res.data.data.providers })
        }
    }


    return (
        <>
            <Tooltip title="Filter">
                <FilterAltIcon
                    className='pointer' style={{
                        margin: "0 1rem 0 1rem"
                    }}
                    onClick={handleClick}
                />
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Container>
                  <FormControl>
                        <strong>By payment status</strong>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue={filterState?.fStatus ? filterState?.fStatus : ""}
                            onChange={handleStatusChange}>
                            <FormControlLabel value="OnHold" control={<Radio />} label="OnHold" />
                            <FormControlLabel value="Captured" control={<Radio />} label="Captured" />
                            <FormControlLabel value="Finalized" control={<Radio />} label="Finalized" />
                            <FormControlLabel value="Refunded" control={<Radio />} label="Refunded" />
                            <FormControlLabel value="PartiallyRefund" control={<Radio />} label="Partially Refund" />
                        </RadioGroup>
                    </FormControl>
                    <Divider /><br />

          {/* <FormControl>
                        <strong>By payment type</strong>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue={filterState?.fpaymentType ? filterState?.fpaymentType : ""}
                            onChange={(e) => setFilterState({ ...filterState, fpaymentType: e.target.value })}>
                            <FormControlLabel value="AdvanceFee" control={<Radio />} label="AdvanceFee" />
                            <FormControlLabel value="jobFee" control={<Radio />} label="JobFee" />
                        </RadioGroup>
                    </FormControl>
                    <Divider /><br /> */}

          {/* <FormControl>
            <strong>By payout status</strong>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              defaultValue={filterState?.fpayoutType ? filterState?.fpayoutType : ""}
              onChange={(e) => {
                setFilterState({ ...filterState, fpayoutType: e.target.value })
                isChanged = true
              }}
            >
              <FormControlLabel value="Paid" control={<Radio />} label="Paid" />
              <FormControlLabel value="Unpaid" control={<Radio />} label="Unpaid" />
            </RadioGroup>
          </FormControl>
          <Divider />
          <br /> */}

                    <FormControl>
                        <strong>By providers</strong>
                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultValue={filterState?.provider ? filterState?.provider : ""}
                            onChange={(e) => { setFilterState({ ...filterState, provider: e.target.value }); isChanged = true }}>
                            <FormControlLabel value="HouseKeeper" control={<Radio />} label="Housekeeper" />
                            <FormControlLabel value="BabySitter" control={<Radio />} label="Babysitter" />
                        </RadioGroup>
                    </FormControl>
                    <Divider /><br />

                    {filterState?.provider && <>
                        <FormControl sx={{ width: '100%', color: 'green' }}>
                            <InputLabel id="city">Provider</InputLabel>
                            <Select
                                className='provider'
                                id='provider'
                                label="Provider"
                                defaultValue={filterState?.userIds}
                            >
                                {provider.list.map((data) =>
                                    <MenuItem value={data._id} onClick={() => { setFilterState({ ...filterState, userInfo: data, userIds: data._id, isApplied: false }); isChanged = true }}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Avatar
                                                alt=""
                                                src={APP_URL + "/" + data.profilePicture}
                                                sx={{ width: 24, height: 24, marginRight: '10px' }}
                                            />
                                            <div style={{ fontSize: '14px' }}>
                                                {data.firstName + " " + data.lastName}
                                                <p style={{ fontSize: '13px' }}>{data.email}</p>
                                            </div>
                                        </div>
                                    </MenuItem>)}
                            </Select>
                        </FormControl>
                        <Divider /><br />
                    </>}



                    {/*FROM AND TO DATE PICKER*/}
                    <div className='date_div'>
                        <strong >By Date</strong>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                            <TextField
                                id='Date From'
                                type={"date"}
                                fullWidth
                                defaultValue={filterState.fStartDate ? moment(filterState.fStartDate).format('YYYY-MM-DD') : ""}
                                // label="Start date"
                                onChange={(e) => {
                                    setFilterState({
                                        ...filterState,
                                        fStartDate: moment(e.target.value).format('YYYY-MM-DD')
                                    });
                                    isChanged = true
                                }}


                            />

                            <TextField
                                id='Date To'
                                type={"date"}
                                fullWidth
                                // label="End date"
                                defaultValue={filterState.fEndDate ? moment(filterState.fEndDate).format('YYYY-MM-DD') : ""}
                                onChange={(e) => {
                                    setFilterState({
                                        ...filterState,
                                        fEndDate: moment(e.target.value).format('YYYY-MM-DD')
                                    });
                                    isChanged = true
                                }}
                            />
                        </Stack>

                    </div>
                    <Divider /><br />
                    <Actions>
                        <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={handleApply}>Apply filter</Button>
                        <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={handleClear}>Clear filter</Button>
                    </Actions>

                </Container>
            </Menu>
        </>
    );
}

const Container = styled("div")`
    padding: 1rem;
    .my-2{
        margin-top: 1rem;
    }
    &>.short_by{
        display: flex;
        flex-direction: column;
        &>div{
            display: flex;
            column-gap: 1rem;
        }
    }
    &>.country_select_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
    &>.date_div{
        margin-bottom: 0.5rem;
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
`;

const Actions = styled("div")`
    margin-top: 1rem;
    display: flex;
    column-gap: 1rem;
`;
